import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';
import SvgIcon from '@mui/material/SvgIcon';
import CheckIcon from '@/component/icons/sf-check-icon';
import { useTheme } from '@mui/material/styles';
import { SFPalette } from '@/lib/color';

const SFSimpleCheckbox = (props: CheckboxProps) => {
  const theme = useTheme();
  return (
    <Checkbox
      {...props}
      checkedIcon={<CheckIcon color={theme.palette.primary.main} />}
      icon={<CheckIcon color={SFPalette.lightGrey2} />}
    />
  );
};

export default SFSimpleCheckbox;
